module.exports = __webpack_public_path__ + "static/media/jalapeno-lime-desktop-en.05f79163.jpg";